import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import ApiBase from '@/api/base';
import {
  UserProfileApi,
  GetCurrentAdminUser200Response,
} from '@/api/openapi';

export class CurrentUserApiService extends ApiService {
  api = new UserProfileApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getCurrentUser({
    options,
    errorHandlers,
  }: ApiArguments<undefined>): Promise<AxiosResponse<GetCurrentAdminUser200Response>> {
    return this.checkResponse<GetCurrentAdminUser200Response>(
      this.api.getCurrentAdminUser(options),
      errorHandlers,
    );
  }
}

export default {
  getCurrentUser (args) {
    return ApiBase.get(`/admin/me`, args);
  },
};
